/* global G */

/**
 * Initializes the application persistence storage.
 *
 * @returns {function(*): Promise<*>}
 */
const init = obj => async (args) => {
  const persistenceAdapter = obj[G.ADAPTER][G.PERSISTENCE][G.API]
  await persistenceAdapter.init()
  return args
}

export default init
